import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import './PaperViewer.css';

// Bundle the worker locally (no CDN) — see public/pdf.worker.min.js
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

/**
 * In-browser reader for the published research paper.
 *
 * Extracted from the former `/docs` page when Docs and Publications were merged.
 * It renders inside the Publications page — the paper no longer has its own route.
 * The PDF itself stays at `/docs/main.pdf` (and stays in robots.txt's Disallow list).
 */
function PaperViewer() {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadError, setLoadError] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  // Block right-click (save/view-source) on the protected viewer
  const handleContextMenu = (e) => e.preventDefault();

  return (
    <div
      className="pv-viewer"
      onContextMenu={handleContextMenu}
      onDragStart={(e) => e.preventDefault()}
    >
      {loadError ? (
        <div className="pv-error">Unable to load the document.</div>
      ) : (
        <Document
          file="/docs/main.pdf"
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={() => setLoadError(true)}
          loading={<div className="pv-loading">Loading document…</div>}
          error={<div className="pv-error">Unable to load the document.</div>}
        >
          <Page
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            width={Math.min(window.innerWidth * 0.9, 960)}
          />
        </Document>
      )}

      <div className="pv-controls">
        <button
          type="button"
          className="btn btn-secondary"
          disabled={pageNumber <= 1}
          onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
        >
          ‹ Prev
        </button>
        <span className="pv-pagenum">
          Page {pageNumber} of {numPages || '—'}
        </span>
        <button
          type="button"
          className="btn btn-secondary"
          disabled={!numPages || pageNumber >= numPages}
          onClick={() => setPageNumber((p) => Math.min(numPages, p + 1))}
        >
          Next ›
        </button>
      </div>
    </div>
  );
}

export default PaperViewer;
